// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"ceb03afc","591":"4796d1ac"}[chunkId] + ".chunk.css";
};